






















































































import { Vue, Component } from "vue-property-decorator";
import { appModule } from "@/store/modules/app";
import { apiTokenModule } from "@/store/modules/apiToken";

@Component
export default class ApiToken extends Vue {
  public dialog = false;
  public dialog2 = false;
  public headers = [
    {
      text: "API name",
      align: "start",
      value: "name"
    },
    { text: "API type", value: "api_type" },
    { text: "uuid", value: "uuid" },
    { text: "API key", value: "api_key_icon", sortable: false },
    { text: "Actions", value: "actions", sortable: false }
  ];

  get loading() {
    return apiTokenModule.loading;
  }

  get api_list() {
    return apiTokenModule.api_list;
  }

  get api_token() {
    return apiTokenModule.api_token;
  }

  set api_token(item) {
    apiTokenModule.setApiToken(item);
  }

  public editedIndex = -1;

  get formTitle() {
    return this.editedIndex === -1 ? "新增API token" : "修改API token";
  }

  editItem(item) {
    this.editedIndex = this.api_list.indexOf(item);
    this.api_token = Object.assign({}, item);
    this.dialog = true;
  }

  apikey(item) {
    this.api_token.name = item.name;
    this.api_token.api_key = item.api_key;
    this.dialog2 = true;
  }

  public copyApi() {
    appModule.sendSuccessNotice("複製成功");
    this.dialog2 = false;
  }

  public onError() {
    appModule.sendErrorNotice("複製失敗");
  }

  public async deleteItem(item) {
    this.api_token = Object.assign({}, item);
    if (confirm("確定要刪除嗎?") == true) {
      apiTokenModule.deleteApi();
    } else {
      appModule.sendErrorNotice("刪除失敗");
    }
  }

  public async resetItem(item) {
    this.api_token = Object.assign({}, item);
    if (confirm("確定要重置API key嗎?") == true) {
      apiTokenModule.resetToken();
    } else {
      appModule.sendErrorNotice("重置失敗");
    }
  }

  close() {
    this.dialog = false;
    this.$nextTick(() => {
      this.editedIndex = -1;
    });
  }

  public async save() {
    if (this.editedIndex == -1) {
      apiTokenModule.createApi();
    } else {
      apiTokenModule.modifyApi();
    }
    this.close();
  }

  created() {
    apiTokenModule.apiList();
  }
}
